// extracted by mini-css-extract-plugin
export default {"global-event-listener-root":"global-event-listener-root-UFqCBUB"};